/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { ExternalProviderLinkModel } from "@insite/client-framework/Services/IdentityService";

export const signInExternalProvidersHandler = (
    e: React.MouseEvent,
    externalProviderParam: ExternalProviderLinkModel | undefined,
    userName: string,
    currentUserIsGuest: boolean,
    externalProviders: ExternalProviderLinkModel[] | undefined,
    signInUrl: string | undefined,
    location: any
) => {
    if ((!userName || currentUserIsGuest) && externalProviders) {
        e.preventDefault();
        if (!externalProviders?.length && !externalProviderParam) {
            return;
        }
        const externalProvider = externalProviderParam || externalProviders[0];
        if (!externalProvider.url) {
            return;
        }
        let returnUrl = "/";
        if (signInUrl && location.pathname.toLowerCase() === signInUrl?.toLowerCase()) {
            returnUrl = parseQueryString<{ returnUrl?: string }>(location.search).returnUrl || "/";
        } else {
            returnUrl = `${location.pathname}${location.search}`;
        }
        returnUrl = `${returnUrl + (returnUrl.indexOf("?") > -1 ? "&" : "?")}forcereturnurl`;
        returnUrl = encodeURIComponent(returnUrl);
        window.location.href = externalProvider.url.replace("returnurl%3a%2f", `returnurl%3a${returnUrl}`);
    }
};
